


































































































































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import MeetupsCardManage from "@/components/Communities/MeetupsCardManage.vue";
import Location from "@/components/Communities/form/Location.vue";
import Description from "@/components/Communities/form/Description.vue";
import SocialContacts from "@/components/Communities/form/SocialContacts.vue";
import Topics from "@/components/Communities/form/Topics.vue";
import Leaders from "@/components/Communities/form/Leaders.vue";
import LogoUpload from "@/components/Communities/form/LogoUpload.vue";
import BannerUpload from "@/components/Communities/form/BannerUpload.vue";
import { formCheck } from "@/services/utils";
import ModalEdit from "@/components/ModalEdit.vue";
import CmBack from "@/components/CmBack.vue";
import CommunityDashboard from "@/components/Communities/pages/CommunityDashboard.vue";
import CodeMessage from "@/components/CodeMessage.vue";

@Component({
    components: {
        MeetupsCardManage,
        Location,
        Description,
        SocialContacts,
        Topics,
        Leaders,
        LogoUpload,
        BannerUpload,
        ModalEdit,
        CommunityDashboard,
        CodeMessage,
        CmBack
    }
})
export default class MyManage extends Vue {
    public sent: boolean = false;
    public logo: boolean = false;
    public showUpdateResult: boolean = false;
    public updateResultMessage: string = "";
    public showMeetupModal: boolean = false;
    public logoFile: any = undefined;
    public coverFile: any = undefined;
    public meetup: any = null;
    public fileSizeError: boolean = false;
    public showSpinner: boolean = false;
    public meetups: any = [];
    public totalMeetups: number = 0;
    public currentMeetupPage: number = 1;
    public reload: boolean = false;
    public modalKey: number = 0;
    public filter: string = "live";
    public currentSection = "dashboard";

    public get filters() {
        return this.$store.getters.meetupFilters;
    }
    public set filters(val) {
        this.$store.commit("setMeetupFilters", val);
    }
    public get nameFilters() {
        return this.filters ? this.filters.name : "";
    }
    public set nameFilters(val) {
        this.filters.name = val;
    }
    // public community: any = {
    //     name: "",
    //     description: "",
    //     leaders: [],
    //     basedIn: [],
    //     topics: [],
    //     social: {
    //         facebook: "",
    //         twitter: "",
    //         linkedin: "",
    //         mail: "",
    //         github: ""
    //     },
    //     logo: null,
    //     cover: null
    // };

    public get community() {
        return this.$store.getters.community;
    }
    public set community(val) {
        this.$store.commit("setCommunity", val);
    }

    public get isMeetups() {
        return this.currentSection === "meetups";
    }

    public get isEdit() {
        return this.currentSection === "edit";
    }

    public get isDashboard() {
        return this.currentSection === "dashboard";
    }

    public errorsCheck: boolean = false;

    public formErrors: any = {
        basedIn: false,
        topics: false
    };
    async mounted() {
        if (this.$route.query.view) {
            switch (this.$route.query.view) {
                case "edit":
                    this.currentSection = "edit";
                    break;
                case "meetups":
                    this.currentSection = "meetups";
                    break;
                case "dashboard":
                default:
                    this.currentSection = "dashboard";
                    break;
            }
        }
        if (!this.community || this.community.id !== this.$route.params.id) {
            this.community = await this.$communityApi.getCommunity(
                this.$route.params.id
            );
        }
        this.filters = this.filters || {
            status: "published",
            name: "",
            live: true
        };
        this.loadMeetups(1);
    }

    public filtersChange(filter, name) {
        if (!this.showSpinner) {
            this.filter = filter;
            switch (filter) {
                case "live":
                    this.filters = {
                        name: this.filters.name,
                        live: true,
                        status: "published"
                    };
                    break;
                case "draft":
                    this.filters = {
                        name: this.filters.name,
                        live: null,
                        status: "draft"
                    };
                    break;
                case "past":
                    this.filters = {
                        name: this.filters.name,
                        live: false,
                        status: "published"
                    };
                    break;
                case "matching":
                    this.filters = {
                        name: name,
                        live: this.filters.live,
                        status: this.filters.status
                    };
                    break;
            }
            this.loadMeetups(1);
        }
    }

    async loadMeetups(page) {
        this.showSpinner = true;
        const meetupPage: any = await this.$meetupApi.getMeetups(
            this.$route.params.id,
            page,
            6,
            this.filters
        );
        this.meetups = meetupPage.data;
        this.totalMeetups = meetupPage.total;
        this.showSpinner = false;
    }

    async communityUpdate() {
        this.formErrors = formCheck(this.community, this.community.logo);
        Object.values(this.formErrors).forEach(el => {
            if (el) {
                this.errorsCheck = true;
                return;
            }
        });
        this.coverFile = (<any>this.$refs.croppa).$refs.croppa
            ? await (<any>this.$refs.croppa).$refs.croppa.promisedBlob(
                  "image/png",
                  0.8
              )
            : undefined;

        if (!this.errorsCheck) {
            await this.uploadCommunity(this.community);
            this.sent = true;
        } else {
            this.showUpdateResult = true;
        }
    }
    async uploadCommunity(community) {
        try {
            const cid = await this.$communityApi.updateCommunity(
                this.$route.params.id,
                community,
                this.logoFile,
                this.coverFile || undefined
            );
            this.updateResultMessage = "Update complete with success!";
        } catch (error) {
            this.updateResultMessage = error.message;
        } finally {
            this.showUpdateResult = true;
        }
    }
    public editMeetup(meetup, cfp) {
        this.$store.commit("setMeetup", { ...meetup });
        this.$router.push({
            name: "meetup-edit",
            params: { id: this.community.id, meetupid: meetup.id },
            query: { cfp: cfp || undefined }
        });

        // this.modalKey++;
        // this.isEdit = true;
        // this.showMeetupModal = true;
    }

    public loadLogo(file) {
        if (file) {
            if (file.size < 250000) {
                this.showUploadPreview(file, true);
                this.logoFile = file;
                this.logo = true;
            } else {
                this.fileSizeError = true;
            }
        }
    }
    public showUploadPreview(file, isLogo) {
        const reader = new FileReader();
        reader.onload = (e: any) =>
            isLogo
                ? (this.community.logo = e.target.result)
                : (this.community.cover = e.target.result);
        reader.readAsDataURL(file);
    }

    @Watch("community.name")
    onCommunityNameChanged(val: string, oldval: string) {
        this.formErrors.name = false;
    }
    @Watch("currentSection")
    onCurrentSectionChange(val: string, oldval: string) {
        this.$router.replace({ name: "manage", query: { view: val } });
    }
    @Watch("community.logo")
    onCommunityLogoChanged(val: boolean, oldval: boolean) {
        this.formErrors.logo = false;
    }
    @Watch("community.basedIn")
    onCommunityBasedInChanged(val: any, oldval: any) {
        this.formErrors.basedIn = false;
    }
    @Watch("community.topics")
    onCommunityTopicsChanged(val: any, oldval: any) {
        this.formErrors.topics = false;
    }
    @Watch("reload")
    async onReloadChanged(val: any, oldval: any) {
        if (!oldval && val) {
            this.loadMeetups(this.currentMeetupPage);
            this.reload = false;
        }
    }
}
